// extracted by mini-css-extract-plugin
export default {"dividerBox":"Divider_dividerBox__ZnL8+","divider":"Divider_divider__E3N1s","vertical":"Divider_vertical__cDmvU","icon":"Divider_icon__vNYRY"};